import { render, staticRenderFns } from "./PwdLessLoginRootComponent.vue?vue&type=template&id=5f9b4927"
import script from "./PwdLessLoginRootComponent.vue?vue&type=script&lang=js"
export * from "./PwdLessLoginRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports